import SendEmail from './components/SendEmail';
import ValidateEmail from './components/ValidateEmail';

export const steps = [
  {
    stepNumber: 1,
    component: SendEmail
  },
  {
    stepNumber: 2,
    component: ValidateEmail
  }
];
